import { NavLink } from "react-router-dom";
import { apiUrlImg } from "../../../../api/api";
import { useEffect } from "react";

export const InformacionEmpresa = ({ empresaDetail }) => {

    const empresa = [
        [
            { label: "Nombre empresa:", value: empresaDetail.nombre_empresa || "--" },
            { label: "Razón social:", value: empresaDetail.razon_social || "--" },
            { label: "Cédula jurídica:", value: empresaDetail.cedula_juridica || "--" },
        ],
        [
            { label: "Página web:", value: empresaDetail.pagina_web || "--" },
            { label: "Teléfono:", value: empresaDetail.telefono || "--" },
            { label: "País:", value: empresaDetail.pais || "--" },
        ],
        [
            { label: "Dirección física:", value: empresaDetail.direccion_fisica || "--" },
            { label: "Industria:", value: empresaDetail.industria || "--" },
            { label: "Tipo de empresa:", value: empresaDetail.tipo_cliente || "--" },
        ],
        [
            { label: "Tiene crédito:", value: empresaDetail.tiene_credito || "--" },
            { label: "Notas importantes:", value: empresaDetail.notas_importantes || "--" },
        ],
    ];
    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const response = await fetch(`${apiUrlImg}${empresaDetail.logoEmpresa}`);
                if (response.ok) {
                    const imageBlob = await response.blob();
                    const imageUrl = URL.createObjectURL(imageBlob);
                    document.querySelector("#logoempresas").src = imageUrl;
                } else {
                    console.error("Failed to load image");
                }
            } catch (error) {
                console.error("Error fetching logo:", error);
            }
        };
        if (empresaDetail.logoEmpresa) fetchLogo();
    }, [empresaDetail.logoEmpresa]);
    return (
        <>
            {" "}
            <div className="card">
                <div className="card-header">
                    <h5>Informacion Completa</h5>
                </div>
                <div className="card-body">
                    <p className="mb-0">Desglose de infromacion relacionada al Empresa</p>
                </div>
            </div>
            <div className="card">
                <div className="card-header">
                    <h5>
                        Empresa{" "}
                    </h5>
                </div>
                <div className="card-body">
                    <h5>Infirmacion Empresa</h5>
                    <div className="chat-avtar d-inline-flex mx-auto">
                        {/* <img id="logoempresas" alt="User image" className="img-fluid img-thumbnail" style={{ width: "200px", height: "auto", color: "transparent" }} /> */}
                        {/* <i className="chat-badge bg-success me-2 mb-2"></i> */}
                    </div>
                    <ul className="list-group list-group-flush">
                        {empresa.map((section, index) => (
                            <li className="list-group-item px-0" key={`client-section-${index}`}>
                                <div className="row">
                                    {section.map((field, idx) => (
                                        <div className="col-md-4" key={`client-field-${idx}`}>
                                            <p className="mb-1 text-muted">{field.label}</p>
                                            <p className="mb-0">{field.value}</p>
                                        </div>
                                    ))}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    );
};
